/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Action_SkippedInputs */

const cs_ebr_action_skipped = /** @type {(inputs: Ebr_Action_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočeno`)
};

const en_ebr_action_skipped = /** @type {(inputs: Ebr_Action_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped`)
};

/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Ebr_Action_SkippedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_action_skipped = /** @type {((inputs?: Ebr_Action_SkippedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Action_SkippedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_action_skipped(inputs)
	return cs_ebr_action_skipped(inputs)
});